import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AdminLoginPage() {
  const { login } = useAuth();
  const location = useLocation();
  const error = location.state?.error;
  return (
    <div className="min-h-screen bg-[#FAF2E8] flex flex-col items-center justify-center px-5" data-testid="admin-login-page">
      <div className="max-w-md w-full bg-white border border-black/5 rounded-2xl shadow-sm p-8 text-center">
        <div className="w-14 h-14 rounded-2xl bg-[#F39200]/10 text-[#F39200] flex items-center justify-center mx-auto">
          <ShieldCheck size={26} />
        </div>
        <h1 className="mt-5 text-2xl font-extrabold text-neutral-900">Admin sign-in</h1>
        <p className="mt-2 text-sm text-neutral-600">Sign in with your allowed Google account to manage blog posts.</p>
        {error && (
          <div className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-4 py-3">{error}</div>
        )}
        <button
          onClick={login}
          data-testid="google-signin-btn"
          className="mt-6 w-full h-11 rounded-lg bg-neutral-900 hover:bg-neutral-800 text-white text-sm font-semibold flex items-center justify-center gap-3 transition-colors"
        >
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C33.6 6.1 29 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.5-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.4 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C33.6 6.1 29 4 24 4 16.4 4 9.9 8.3 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c4.9 0 9.4-1.9 12.8-5l-5.9-5c-2 1.4-4.5 2.2-6.9 2.2-5.3 0-9.7-3.4-11.3-8l-6.6 5.1C9.7 39.6 16.3 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.5l5.9 5C40.9 35 44 30 44 24c0-1.3-.1-2.5-.4-3.5z"/>
          </svg>
          Continue with Google
        </button>
        <Link to="/" className="mt-6 inline-block text-xs text-neutral-500 hover:text-neutral-800">← Back to site</Link>
      </div>
    </div>
  );
}
